import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
// Types

var defaultOptions = {
  layer: 'dataLayer',
  // script
  scriptId: 'gtm-script',
  scriptURL: 'https://www.googletagmanager.com/gtm.js',
  // no script backup
  noscript: true,
  noscriptId: 'gtm-noscript',
  noscriptURL: 'https://www.googletagmanager.com/ns.html'
};

// doNotTrack polyfill
// https://gist.github.com/pi0/a76fd97c4ea259c89f728a4a8ebca741
var dnt = "(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled')";

/**
 *
 * @param context
 * @param inject
 */
export var gtmPlugin = function gtmPlugin(context, inject) {
  // Inject bootstrap GTM function (can be called multiple times for different GTM IDs)
  inject('bootstrapGTM', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(callOptions) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              if (process.client !== true) return;
              var options = _objectSpread(_objectSpread({}, defaultOptions), callOptions);
              if (window.__cavu_gtm_plugin__ === undefined) {
                window.__cavu_gtm_plugin__ = {};
              }
              if (window.__cavu_gtm_plugin__[options.id] === undefined) {
                window.__cavu_gtm_plugin__[options.id] = {
                  called: false,
                  layer: options.layer,
                  loaded: false
                };
              }
              if (window.__cavu_gtm_plugin__[options.id].called === true) {
                return;
              }
              window.__cavu_gtm_plugin__[options.id].called = true;
              var injectScript = "var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='".concat(options.scriptURL + '?id=\'+i', ";f.parentNode.insertBefore(j,f)");
              var doNotTrackScript = 'if(w.doNotTrack||w[x][i])return;';
              var initLayer = "w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'})";
              var scriptInnerHTML = "w[x]={};w._gtm_inject=function(i){".concat(doNotTrackScript, "w[x][i]=1;").concat(initLayer, ";").concat(injectScript, ";}");
              if (options.id) {
                scriptInnerHTML += ";w[y]('".concat(options.id, "')");
              }
              scriptInnerHTML = "".concat(dnt, ";(function(w,d,s,l,x,y){").concat(scriptInnerHTML, "})(window,document,'script','").concat(options.layer, "','_gtm_ids','_gtm_inject')");
              scriptInnerHTML = "if(!window['_gtm_init_".concat(options.id, "']){window['_gtm_init_").concat(options.id, "']=1;").concat(scriptInnerHTML, ";window._gtm_inject('").concat(options.id, "')}");
              var script = document.createElement('script');
              script.type = 'text/javascript';
              script.async = true;
              script.innerHTML = scriptInnerHTML;
              script.onload = function () {
                resolve(options.id);
                window.__cavu_gtm_plugin__[options.id].loaded = true;
              };
              script.onerror = function () {
                return reject(options.id);
              };
              document.head.appendChild(script);
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  inject('gtm', {
    push: function push(data, id) {
      var layer = id ? window.__cavu_gtm_plugin__[id].layer : defaultOptions.layer;

      // @ts-expect-error - this error occurs because we cannot type the windw object with
      // a dynamic key, but we are confident that the key (should) exist(s)
      var dataLayer = window[layer] || (window[layer] = []);

      // Push the data to the dataLayer
      dataLayer.push(data);
    }
  });
};
export default gtmPlugin;